import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CredentialsService } from './authentication/credentials.service';
import { environment } from '@env/environment';
import { AuthenticationService } from './authentication/authentication.service';
import { Observable } from 'rxjs';
import { NameDisplayFormat } from '@app/reservation/reservation-settings/reservation-settings.model';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  constructor(
    private http: HttpClient,
    private credentialsService: CredentialsService,
    private authService: AuthenticationService
  ) {}

  getNewsArticles(): Observable<any> {
    const cred = this.credentialsService.credentials;
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + cred.token
    });

    return this.http
      .get<any>(`https://blog.gastro.digital/wp-json/wp/v2/posts?page=1&per_page=5`, {
        headers: headers
      })
      .pipe(
        map((articles: any) => {
          return articles;
        })
      );
  }

  formatName(
    firstName?: string | null,
    lastName?: string | null,
    format: NameDisplayFormat = NameDisplayFormat.LastFirst
  ): string {
    const f = firstName ? firstName.trim() : '';
    const l = lastName ? lastName.trim() : '';

    const fI = f ? `${f.charAt(0)}.` : '';
    const lI = l ? `${l.charAt(0)}.` : '';

    const join = (...parts: string[]) =>
      parts
        .filter(Boolean)
        .join(' ')
        .trim();

    switch (format) {
      case NameDisplayFormat.FirstLast:
        return join(f, l);
      case NameDisplayFormat.LastFirst:
        return join(l, f);
      case NameDisplayFormat.FirstLastInitial:
        return join(f, lI);
      case NameDisplayFormat.FirstInitialLast:
        return join(fI, l);
      case NameDisplayFormat.LastInitialFirst:
        return join(lI, f);
      case NameDisplayFormat.LastFirstInitial:
        return join(l, fI);
      default:
        return join(l, f);
    }
  }
}
